module.exports = __webpack_public_path__ + "img/iwase.220e00ff.jpg";